var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"cc_center1"}},[_c('div',{staticClass:"cc-header"},[_vm._v("最受欢迎课程排名")]),_c('dv-scroll-board',{staticClass:"likeclass_rank",attrs:{"config":_vm.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }